/** @deprecated Use {@link HexagonGridTile} — kept for legacy callers. */
export const HEXAGON_TILE_COLOR_TRANSITION_CLASS =
	"duration-300 ease-[cubic-bezier(.4,2,.35,1)]";

export interface HexagonTileStyleInput {
	isTranslucent?: boolean;
	isHovered?: boolean;
	isInTrail?: boolean;
}

/** @deprecated Use {@link HexagonGridTile}. */
export function getHexagonGridCellClassName(
	input: HexagonTileStyleInput,
): string {
	void input;
	return "relative size-full [clip-path:var(--hex-tile-outer-clip)]";
}

/** @deprecated Use {@link HexagonGridTile} for grid cells only. */
export interface HexagonTileStyleInputLegacy extends HexagonTileStyleInput {
	isPath?: boolean;
	isCompleted?: boolean;
	isSelected?: boolean;
}

/** @deprecated Path tiles use {@link HexagonPathTile}. */
export function getHexagonCellClassName(
	input: HexagonTileStyleInputLegacy,
): string {
	if (input.isPath) {
		return "relative size-full";
	}
	return getHexagonGridCellClassName(input);
}
